import { v4 } from 'uuid';
import { IRoom, IGuest } from '@share/common-types';

export const getEmptyKid = (): IGuest => {
  return {
    id: v4(),
    age: 0,
  };
};

export const guestsCount = (room: IRoom[]): number => {
  const defaultChildrenCount = 0;
  const startCount = 0;
  const adultsCount: number = room.reduce((res: number, { adultsCount }) => {
    return res + adultsCount;
  }, startCount);
  const childrenCount: number = room.reduce((res: number, { kids }) => {
    return res + (kids?.length || 0);
  }, startCount);

  return adultsCount + (childrenCount ? childrenCount : defaultChildrenCount);
};

export const isSameRooms = (r1: IRoom[] = [], r2: IRoom[] = []) => {
  if (r1.length !== r2.length) return false;

  return r1.every((room1, i) => {
    const room2 = r2[i];

    return (
      room1.adultsCount === room2.adultsCount &&
      (room1.kids?.length || 0) === (room2.kids?.length || 0)
    );
  });
};
